import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Loader2 } from 'lucide-react';
import { useSession } from '@/contexts/session-context';
import { sanitizeReturnTo } from '@/lib/sanitize-return-to';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoading, user, signIn } = useSession();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading && !user) {
      const candidate = location.pathname + location.search;
      sessionStorage.setItem(
        'hookmyapp:auth:returnTo',
        sanitizeReturnTo(candidate),
      );
      signIn({ returnTo: candidate });
    }
  }, [isLoading, user, signIn, location.pathname, location.search]);

  if (isLoading && !user) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) return null;
  return <>{children}</>;
}
